module.exports = __webpack_public_path__ + "static/media/lending-tools8.314ca640.svg";